// import { Gauge, gaugeClasses } from "@mui/x-charts/Gauge";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { IoInformationCircleOutline } from "react-icons/io5";

const CreditInformationCard = () => {
  const percentage = 75;

  const recommendations = [
    "lore ipsum dolor sit amet consectetur adipisicing elit.",
    "lore ipsum dolor sit amet consectetur adipisicing elit.",
    "lore ipsum dolor sit amet consectetur adipisicing elit.",
    "lore ipsum dolor sit amet consectetur adipisicing elit.",
    "lore ipsum dolor sit amet consectetur adipisicing elit.",
  ];

  return (
    <div className="max-w-full rounded-lg bg-white shadow-md">
      <div className="flex items-center justify-between p-4 ">
        <h3 className="text-lg font-medium">Credit Information</h3>
        <p className="font-medium text-primaryPurple-100">Trade</p>
      </div>
      <div className="h-[0.5px] w-full bg-gray-300"></div>
      <div className="p-4">
        <div className="mx-auto flex items-start gap-2">
          <IoInformationCircleOutline className="text-black" size={22} />
          <p className="basis-[90%] text-[#231F2099]">
            Your credit score is a number that represents your creditworthiness.
          </p>
        </div>
        {/* <CircularProgressbar value={percentage} text={`${percentage}/100`} className="max-h-56" />; */}
        <div className="my-2 max-h-72">
          <CircularProgressbar
            value={percentage}
            text={`${percentage}/100`}
            circleRatio={0.75}
            className="max-h-72 font-bold"
            styles={buildStyles({
              rotation: 1 / 2 + 1 / 8,
              strokeLinecap: "butt",
              trailColor: "#CF3D9633",
              pathColor: "#CF3D96",
              textSize: "12px",
              textColor: "#231F20",
            })}
            strokeWidth={20}
          />
        </div>
        <div>
          <h3 className="font-medium">Recommendations</h3>
          {recommendations.map((recommendation, index) => {
            return (
              <div className="flex">
                <p key={index} className="text-[#231F2099]">
                  {recommendation}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CreditInformationCard;
